import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({ providedIn: "root" })
export class InvoiceService {
  constructor(private http: HttpUtilService) {}

  getDetailsByContractNo(contractNo: string): Observable<any> {
    const encodedContractNo = encodeURIComponent(`"${contractNo.trim()}"`);
    return this.http.get(
      `InvoiceService.asmx/GetDetailsByContractNo?contractNo=${encodedContractNo}`,
    );
  }

  getEnableButton(contractNo: string): Observable<any> {
    const encodedContractNo = encodeURIComponent(`"${contractNo.trim()}"`);
    return this.http.get(
      `InvoiceService.asmx/GetEnableButton?ContractNo=${encodedContractNo}`,
    );
  }
}
